module.exports = __webpack_public_path__ + "static/media/dashboard.d141e2b1.svg";